import {listener} from "../../../../../modules/vegas/js/util";
import Cart from "./cart";

listener('change', '[data-product-cart-item] [name="p[]"]', (el, e) => {
	new Cart().update();
})
